'use client';

import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/esm/Page/TextLayer.css';

import { useEffect, useRef, useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';

import styles from './Pdf.module.css';
import { Pagination } from '../pagination';
import { Spinner } from '../spinner';

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

interface PdfProps {
  url: string;
}

export function Pdf({ url }: PdfProps) {
  const containerRef = useRef(null);

  const [containerWidth, setContainerWidth] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [maxPages, setMaxPages] = useState(0);

  useEffect(() => {
    if (containerRef.current) setContainerWidth((containerRef.current as TypeAny).offsetWidth);
  }, [containerRef]);

  function onDocumentLoadSuccess({ numPages: nextNumPages }: TypeAny): void {
    setMaxPages(nextNumPages);
  }

  return (
    <div className={styles.pdf} key={`pdf-${url}`} ref={containerRef}>
      {maxPages > 1 && (
        <Pagination
          currentPage={currentPage - 1}
          handleNextPage={() => setCurrentPage((prevState) => prevState + 1)}
          handlePrevPage={() => setCurrentPage((prevState) => prevState - 1)}
          maxPages={maxPages}
          hasMore={currentPage < maxPages}
        />
      )}

      <div className={styles.pdf__pages}>
        <Document
          error=""
          file={url}
          loading={
            <div>
              <Spinner hasWrapper />
            </div>
          }
          noData=""
          onLoadSuccess={onDocumentLoadSuccess}
        >
          <Page pageNumber={currentPage} width={containerWidth / 2} />
        </Document>

        <Document error="" file={url} loading="" noData="" onLoadSuccess={onDocumentLoadSuccess}>
          <Page error="" pageNumber={currentPage + 1} width={containerWidth / 2} />
        </Document>
      </div>
    </div>
  );
}
